import React from 'react';
import styled from 'styled-components';

import { Box, Display, Flex, Image, Paragraph } from '@rover/kibble/core';
import { DSTokenMap } from '@rover/kibble/styles';
import UnorderedList from '@rover/react-lib/src/components/lists/UnorderedList/UnorderedList';
import AndroidAppStoreButton from '@rover/react-lib/src/pages/shared/AppStoreCallout/AndroidAppStoreButton';
import IosAppStoreButton from '@rover/react-lib/src/pages/shared/AppStoreCallout/IosAppStoreButton';

import phoneImage from './images/sdv-phone.webp';

export type Props = {
  headingText: React.ReactNode;
  introText: React.ReactNode;
  listItems: React.ReactNodeArray;
};

const ButtonContainer = styled(Flex)`
  & > * {
    padding: 0;
    padding-right: ${DSTokenMap.SPACE_6X};

    &:last-child {
      padding-right: 0;
    }
  }
`;

const GetDetailedUpdates = ({ headingText, introText, listItems }: Props): JSX.Element => (
  <Flex
    alignItems="center"
    my="12x"
    flexDirection="column"
    data-qa-id="service-landing-sdv-callout"
  >
    <Box maxWidth={['83.3333%', '66.6666%']} textAlign="center">
      <Display as="h3" size="400" mb="3x">
        {headingText}
      </Display>
    </Box>

    <Flex gap="4x" maxWidth="83.3333%" flexDirection={['column', 'row']} alignItems="center">
      <Box marginY="6x" textAlign="center" height="475" flex="1 1 50%">
        <Image src={phoneImage} description="" height="475" width="auto" />
      </Box>

      <Box marginY="6x" maxWidth="83.3333%" flex="1 1 50%">
        <Paragraph textAlign="left">{introText}</Paragraph>

        <UnorderedList centered={false}>{listItems}</UnorderedList>

        <ButtonContainer marginTop="8x" alignItems="flex-start" flexWrap="wrap">
          <IosAppStoreButton />
          <AndroidAppStoreButton />
        </ButtonContainer>
      </Box>
    </Flex>
  </Flex>
);

export default GetDetailedUpdates;
